import { docPages } from './docs.generated';

export function getDocBySlug(slug) {
  return docPages.find((doc) => doc.slug === slug) || null;
}

export function filterDocs({ access } = {}) {
  if (!access) {
    return [...docPages];
  }
  return docPages.filter((doc) => doc.access === access);
}

export function groupDocs(pages) {
  const groups = new Map();

  for (const page of pages) {
    if (!groups.has(page.group)) {
      groups.set(page.group, {
        id: page.group,
        label: page.groupLabel,
        order: page.groupOrder,
        pages: [],
      });
    }
    groups.get(page.group).pages.push(page);
  }

  return [...groups.values()]
    .map((group) => ({
      ...group,
      pages: [...group.pages].sort((a, b) => {
        if (a.order !== b.order) {
          return a.order - b.order;
        }
        return a.title.localeCompare(b.title);
      }),
    }))
    .sort((a, b) => {
      if (a.order !== b.order) {
        return a.order - b.order;
      }
      return a.label.localeCompare(b.label);
    });
}
